import React, { useState, useEffect } from 'react';
import Splash from './components/Splash';
import DownloadPage from './components/DownloadPage';
import SearchPage from './components/SearchPage';
import AIPage from './components/AIPage';
import LyricsPage from './components/LyricsPage';

const API = process.env.REACT_APP_API_URL || '/api';

export const api = API;

export default function App() {
  const [splash, setSplash] = useState(true);
  const [tab, setTab] = useState('search');

  useEffect(() => {
    const t = setTimeout(() => setSplash(false), 3100);
    return () => clearTimeout(t);
  }, []);

  const tabs = [
    { id: 'search',   icon: '🔍', label: 'Recherche' },
    { id: 'ai',       icon: '🤖', label: 'IA' },
  ];

  return (
    <>
      {splash && <Splash />}
      <div className="app">
        <header className="header">
          <div>
            <div className="header-logo">hé pardon!!</div>
            <div className="header-sub">Music · Download · IA</div>
          </div>
          <span style={{ fontSize: 28 }}>🎶</span>
        </header>

        <main>
          {tab === 'search'   && <SearchPage />}
          {tab === 'ai'       && <AIPage />}
          {tab === 'lyrics'   && <LyricsPage />}
        </main>

        <nav className="tabs">
          {tabs.map(t => (
            <button key={t.id} className={`tab-btn ${tab === t.id ? 'active' : ''}`} onClick={() => setTab(t.id)}>
              <span className="tab-icon">{t.icon}</span>
              <span>{t.label}</span>
            </button>
          ))}
        </nav>
      </div>
    </>
  );
}
